<template>
  <v-toolbar
    flat
    class="secondary"
  >
    <v-container fluid>
      <v-row>
        <v-icon
          v-if="$vuetify.breakpoint.mdAndDown"
          class="hidden-lg-and-up"
          @click="toggleDrawer"
        >
          fas fa-bars
        </v-icon>
        <v-spacer v-if="$vuetify.breakpoint.mdAndDown" />
        <v-img
          :src="require('@/assets/logo-b2-dark-text.svg')"
          class="mx-5"
          contain
          max-width="134px"
          height="100%"
          aspect-ratio="16/9"
          @click="$vuetify.goTo(0)"
        />
        <v-spacer />
        <v-col
          v-if="$vuetify.breakpoint.lgAndUp"
          class="grow text-right"
        >
          <v-btn
            v-for="(lang, i) in langs"
            :key="`Lang${i}`"
            fab
            small
            text
            class="lang-button"
            :class="{ 'primary--text': $root.locale === lang.value }"
            @click="changeLocale(lang.value)"
          >
            {{ lang.text }}
          </v-btn>
        </v-col>
        <v-menu
          v-else
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-icon
              color="primary"
              dark
              v-on="on"
            >
              fas fa-ellipsis-v
            </v-icon>
          </template>
          <v-list>
            <v-list-item
              v-for="(lang, i) in langs"
              :key="`Lang${i}`"
              :class="{ 'primary--text': $root.locale === lang.value }"
              @click="changeLocale(lang.value)"
            >
              <v-list-item-title>{{ lang.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-container>
  </v-toolbar>
</template>

<script>
  export default {
    data: () => ({
      langs: [
        {
          text: 'FI',
          value: 'fi'
        },
        {
          text: 'SE',
          value: 'se'
        },
        {
          text: 'EN',
          value: 'en'
        }
      ]
    }),
    methods: {
      changeLocale (locale) {
        this.$store.commit('setLocale', locale)
        window.dispatchEvent(new Event('resize'))
      },
      toggleDrawer () {
        this.$store.commit('setDrawer', true)
      }
    }
  }
</script>
